module.exports = __webpack_public_path__ + "img/appointed.ea6e2131.png";